import {
	CalendarCommonModule,
	CalendarDayModule,
	CalendarEvent,
	CalendarEventTimesChangedEvent,
	CalendarWeekModule,
} from 'angular-calendar';
import { Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CalendarEventOffcanvasService } from '@schedule/lib/services/calendar-event-offcanvas-service/calendar-event-offcanvas-service.service';
import { ScheduledEvent } from '@schedule/models/calendar/calendar.model';
import { CalendarSettings, CalendarSettingsService } from '@schedule/services/calendar/calendar-settings/calendar-settings.service';

@Component({
	selector: 'app-calendar-day-view',
	imports: [CommonModule, CalendarDayModule, CalendarWeekModule, CalendarCommonModule],
	templateUrl: './calendar-day-view.component.html',
	styleUrl: './calendar-day-view.component.scss',
})
export class CalendarDayViewComponent implements OnInit, OnChanges, AfterViewInit {
	protected calendarSettings: CalendarSettings;

	@Input() events: CalendarEvent[];
	@Input() viewDate: Date;
	@Input() refresh: Subject<void>;
	@Input() disableOnClick: boolean = false;
	@Input() autoScrollView: boolean = true;
	@Output() eventClicked = new EventEmitter<CalendarEvent>();
	@Output() eventTimesChanged = new EventEmitter<CalendarEventTimesChangedEvent>();
	@Output() hourSegmentClicked = new EventEmitter<{ date: Date; sourceEvent: MouseEvent }>();

	private calendarSettingsService = inject(CalendarSettingsService);
	private calendarOffcanvasService = inject(CalendarEventOffcanvasService);

	ngOnInit(): void {
		this.calendarSettings = this.calendarSettingsService.getDefaultSettings();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.events.currentValue && this.calendarOffcanvasService.currentEvent) {
			const event = this.events.find(
				(e: CalendarEvent<ScheduledEvent>) =>
					e.meta?.scheduledAssessmentId === this.calendarOffcanvasService.currentEvent?.meta?.scheduledAssessmentId,
			);
			if (event) {
				this.calendarOffcanvasService.updateCalendarEvent(event);
			}
		}
	}

	ngAfterViewInit(): void {
		if (this.autoScrollView) {
			setTimeout(() => {
				const newAssessmentElements = document.querySelectorAll('.event-title');
				const timeElements = document.querySelectorAll('.cal-time');

				const newAssessmentTarget = Array.from(newAssessmentElements).find((el) =>
					el.textContent?.trim().includes('New Assessment'),
				);
				const timeTarget = Array.from(timeElements).find((el) => el.textContent?.trim() === '6 AM');

				if (newAssessmentTarget) {
					newAssessmentTarget.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
				} else if (timeTarget) {
					timeTarget.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
				}
			}, 300);
		}
	}

	handleEventClicked(event: CalendarEvent): void {
		this.eventClicked.emit(event);
	}

	showCalendarOffcanvas(event: CalendarEvent<ScheduledEvent>): void {
		if (this.disableOnClick) {
			return;
		}
		this.calendarOffcanvasService.showOffcanvas(event);
	}

	handleEventTimesChanged(event: CalendarEventTimesChangedEvent): void {
		this.eventTimesChanged.emit(event);
	}

	handleHourSegmentClicked($event: { date: Date; sourceEvent: MouseEvent }) {
		this.hourSegmentClicked.emit($event);
	}
}
